export default __webpack_public_path__ + "static/media/3.e4772856.png";